import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {InteractionEvent, InteractionService, InteractionSubjectData} from "../../service/interaction.service";
import {CarouselPageEvent} from "primeng/carousel";
import {Subscription} from "rxjs";
import {AppMessageService} from "../../../core/service/app-message.service";


@Component({
  selector: 'app-interaction-step',
  template: ``,
})
export class InteractionStepComponent extends CoreComponent implements OnInit, OnDestroy, OnChanges {

  @Input() public interactionData?: InteractionSubjectData;
  @Input() override busy: boolean = false;
  eventSubscription?: Subscription;

  constructor(
    protected interactionService: InteractionService,
    protected messageService: AppMessageService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.initComponent();

    this.refreshComponent();
  }

  handleEvent(event: InteractionEvent) {

  }

  initComponent() {

    this.eventSubscription = this.interactionService.eventSubject.subscribe(value => {
      this.handleEvent(value);
    });

    // convert the interaction INTRO information so that the information can be viewed
    this.initialized = true;

  }

  refreshComponent() {

  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes["interactionData"]) {
      this.refreshComponent();
    }

  }


  override ngOnDestroy() {
    super.ngOnDestroy();

    this.eventSubscription?.unsubscribe();
  }

}
